/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

export const listSystemItemTagsGql = gql`
  query listLineItemTags {
    listLineItemTags
  }
`;

export const upsertLineItemTagsGql = gql`
  mutation upsertLineItemTags($input: [LineItemTagUpdateInput!]!) {
    upsertLineItemTags(input: $input) {
      updatedLineItemTags {
        lineItemId
        tags {
          tagName
          expiry
          createdAt
          isSystemTag
        }
      }
    }
  }
`;
